import clsx from "clsx";
import { memo } from "react";
import { formatarDataHoraLocalBR } from "@/utils/validators/date";
import type { AssistenteIAMensagem } from "../types";
import MarkdownMessage from "./MarkdownMessage";
import MessageAvatar from "./MessageAvatar";

const MessageBubble = memo(function MessageBubble({ mensagem }: { readonly mensagem: AssistenteIAMensagem }) {
	const ehUsuario = mensagem.papel === "usuario";

	return (
		<div className={clsx("flex gap-2", ehUsuario ? "justify-end" : "justify-start")}>
			{!ehUsuario && <MessageAvatar />}
			<div
				className={clsx(
					"max-w-[80%] rounded-2xl px-3 py-2 text-sm shadow-sm",
					ehUsuario
						? "rounded-br-md bg-secondary text-secondary-foreground"
						: "rounded-bl-md border bg-background",
					mensagem.status === "erro" && !ehUsuario ? "border-warning/40 bg-warning/10" : "",
				)}
			>
				{ehUsuario ? (
					<p className="whitespace-pre-wrap leading-relaxed">{mensagem.conteudo}</p>
				) : (
					<MarkdownMessage conteudo={mensagem.conteudo} />
				)}
				<span
					className={clsx(
						"mt-1 block text-xs",
						ehUsuario ? "text-secondary-foreground/75" : "text-muted-foreground",
					)}
				>
					{formatarDataHoraLocalBR(mensagem.criadoEm) ?? ""}
				</span>
			</div>
		</div>
	);
});

export default MessageBubble;
